/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Finding_Status_Not_OpenInputs */

const es_co2_error_finding_status_not_open = /** @type {(inputs: Error_Finding_Status_Not_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este hallazgo ya fue registrado.`)
};

/**

* @param {Error_Finding_Status_Not_OpenInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_finding_status_not_open = /** @type {((inputs?: Error_Finding_Status_Not_OpenInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Finding_Status_Not_OpenInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_finding_status_not_open(inputs)
});